import { apiFetch } from "./client.ts";

// Agent Registry
export async function listAgentRegistrations(token: string | null, status?: string) {
  const params = new URLSearchParams();
  if (status) params.set("status", status);
  return apiFetch(`/api/v1/ops/agents?${params}`, { token });
}

export async function registerAgent(token: string | null, data: {
  name: string; displayName: string; capabilities: string[];
  permissions: string[]; version: string; description?: string;
}) {
  return apiFetch("/api/v1/ops/agents", { token, method: "POST", body: JSON.stringify(data) });
}

export async function agentHeartbeat(token: string | null, name: string) {
  return apiFetch(`/api/v1/ops/agents/${name}/heartbeat`, { token, method: "POST", body: JSON.stringify({}) });
}

// Scheduler
export async function listScheduledJobs(token: string | null, params?: { agentName?: string; enabled?: boolean }) {
  const q = new URLSearchParams();
  if (params?.agentName) q.set("agentName", params.agentName);
  if (params?.enabled !== undefined) q.set("enabled", String(params.enabled));
  return apiFetch(`/api/v1/ops/scheduler?${q}`, { token });
}

export async function createScheduledJob(token: string | null, data: {
  name: string; agentName: string; jobType: string;
  cronExpression?: string; input?: Record<string, unknown>; priority?: string;
  maxRetries?: number; nextRunAt?: string;
}) {
  return apiFetch("/api/v1/ops/scheduler", { token, method: "POST", body: JSON.stringify(data) });
}

export async function enableScheduledJob(token: string | null, id: string, version: number) {
  return apiFetch(`/api/v1/ops/scheduler/${id}/enable`, { token, method: "POST", body: JSON.stringify({ version }) });
}

export async function disableScheduledJob(token: string | null, id: string, version: number) {
  return apiFetch(`/api/v1/ops/scheduler/${id}/disable`, { token, method: "POST", body: JSON.stringify({ version }) });
}

// Execution Plans
export async function listExecutionPlans(token: string | null, status?: string) {
  const q = new URLSearchParams();
  if (status) q.set("status", status);
  return apiFetch(`/api/v1/ops/plans?${q}`, { token });
}

export async function createExecutionPlan(token: string | null, data: { goal: string; context?: string; availableAgents?: string[] }) {
  return apiFetch("/api/v1/ops/plans", { token, method: "POST", body: JSON.stringify(data) });
}

// Tool Registry
export async function listTools(token: string | null, params?: { category?: string; enabled?: boolean }) {
  const q = new URLSearchParams();
  if (params?.category) q.set("category", params.category);
  if (params?.enabled !== undefined) q.set("enabled", String(params.enabled));
  return apiFetch(`/api/v1/ops/tools?${q}`, { token });
}

export async function getToolStats(token: string | null, since?: string) {
  const q = new URLSearchParams();
  if (since) q.set("since", since);
  return apiFetch(`/api/v1/ops/tools/stats?${q}`, { token });
}

export async function seedBuiltinTools(token: string | null) {
  return apiFetch("/api/v1/ops/tools/seed", { token, method: "POST", body: JSON.stringify({}) });
}

// Costs & Metrics
export async function getCostSummary(token: string | null, params?: { since?: string; agentName?: string }) {
  const q = new URLSearchParams();
  if (params?.since) q.set("since", params.since);
  if (params?.agentName) q.set("agentName", params.agentName);
  return apiFetch(`/api/v1/ops/costs/summary?${q}`, { token });
}

export async function getCostByAgent(token: string | null, since?: string) {
  const q = new URLSearchParams();
  if (since) q.set("since", since);
  return apiFetch(`/api/v1/ops/costs/by-agent?${q}`, { token });
}

export async function getCostByDay(token: string | null, params?: { since?: string; limit?: number }) {
  const q = new URLSearchParams();
  if (params?.since) q.set("since", params.since);
  if (params?.limit) q.set("limit", String(params.limit));
  return apiFetch(`/api/v1/ops/costs/by-day?${q}`, { token });
}

export async function getCostRecords(token: string | null, params?: { agentName?: string; since?: string; limit?: number }) {
  const q = new URLSearchParams();
  if (params?.agentName) q.set("agentName", params.agentName);
  if (params?.since) q.set("since", params.since);
  if (params?.limit) q.set("limit", String(params.limit));
  return apiFetch(`/api/v1/ops/costs/records?${q}`, { token });
}

export async function getLatestMetrics(token: string | null) {
  return apiFetch("/api/v1/ops/costs/metrics", { token });
}

// Runtime Monitor
export async function getRuntimeStatus(token: string | null) {
  return apiFetch("/api/v1/ops/runtime/status", { token });
}

export async function getRuntimeJobs(token: string | null, params?: { status?: string; agentName?: string; limit?: number }) {
  const q = new URLSearchParams();
  if (params?.status) q.set("status", params.status);
  if (params?.agentName) q.set("agentName", params.agentName);
  if (params?.limit) q.set("limit", String(params.limit));
  return apiFetch(`/api/v1/ops/runtime/jobs?${q}`, { token });
}
